module.exports = __webpack_public_path__ + "img/instagram.cf8f9fb9.svg";